import { render, staticRenderFns } from "./AppColorChip.vue?vue&type=template&id=ac1741a0&scoped=true"
import script from "./AppColorChip.vue?vue&type=script&lang=js"
export * from "./AppColorChip.vue?vue&type=script&lang=js"
import style0 from "./AppColorChip.vue?vue&type=style&index=0&id=ac1741a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1741a0",
  null
  
)

export default component.exports